import RandomIdGenerator from '@/utils/RandomIdGenerator'

export default {
  data () {
    return {
      id: RandomIdGenerator.newId(),
      selectedAirport: '',
      widgetShown: true,
      airportSelectShown: false,
      mapData: {},
      regions: [],
      airports: [],
      destinationAirports: [],
      regionMarkers: [],
      destinationAirportsMarkers: [],
    }
  },
  methods: {
    setMapData (json) {
      this.mapData = json
    },

    toggleWidget () {
      this.widgetShown = !this.widgetShown
    },
  
    toggleAirportSelect () {
      this.airportSelectShown = !this.airportSelectShown
    },
  
    setDefaultSelectTitle () {
      this.selectedAirport = 'Wszystkie lotniska wylotu'
    },

    markersToActivate (markersToFilter, markersToSelect, icon) {
      return markersToFilter.filter(marker => {
        const markerLat = this.setMarkerLatPosition(marker)
        const markerLng = this.setMarkerLngPosition(marker)
  
        marker.setIcon(icon)
        
        for (const _marker in markersToSelect) {
          const _markerLat = this.setMarkerLatPosition(markersToSelect[_marker])
          const _markerLng = this.setMarkerLngPosition(markersToSelect[_marker])
          
          if ((markerLat === _markerLat) && (markerLng === _markerLng)) {  
            return marker
          }
        }
        
        return null
      })
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/googleMap/InteractiveMapMixin.js